module.exports = "/assets/data/0882f2bef43bafa26983916181242138-LE17.data.json";